export const appsConfig = {
  getdata: {
    type: 'app',
    url: '/getdata',
    size: 'big',
    icon: 'GetData',
  },
  lendbot: {
    type: 'app',
    url: '/lendbot',
    size: 'big',
    icon: 'Lendbot',
  },
  vizdata: {
    type: 'tool',
    url: '/vizdata',
    size: 'small',
    icon: 'Vizdata',
  },
  facesign: {
    type: 'tool',
    url: '/facesign',
    size: 'small',
    icon: 'Facesign',
  },
  accord: {
    type: 'tool',
    url: '/accord',
    size: 'small',
    icon: 'Accord',
  },
  connect: {
    type: 'tool',
    url: '/connect',
    size: 'small',
    icon: 'Connect',
  },
  consent: {
    type: 'tool',
    url: '/consent',
    size: 'small',
    icon: 'Consent',
  },
  tou: {
    type: 'tool',
    url: '/tou',
    size: 'small',
    icon: 'Tou',
  },
  jscipher: {
    type: 'tool',
    url: '/jscipher',
    size: 'small',
    icon: 'JSCipher',
  },
  /* rules: {
    type: 'app',
    url: '/rules',
    size: 'big',
    icon: 'Rules',
  }, */
  fleet: { //This product is a name change of Rules
    type: 'app',
    url: '/fleet',
    size: 'big',
    icon: 'Rules',
  }
};
